<template>
  <el-drawer v-model="visible" title="添加/编辑部门">
    <el-form :model="unit" ref="unitForm" :rules="rules" label-width="100px">
      <el-form-item label="部门名称:" prop="name">
        <el-input v-model="unit.name"></el-input>
      </el-form-item>
      <el-form-item label="部门简称:" prop="briefName">
        <el-input v-model="unit.briefName"></el-input>
      </el-form-item>
      <el-form-item label="上级部门:" v-if="unit.pid">
        <el-input v-model="unit.parentName" disabled></el-input>
      </el-form-item>
      <el-form-item label="负责人:">
        <el-input v-model="unit.contactName"></el-input>
      </el-form-item>
      <el-form-item label="联系电话:">
        <el-input v-model="unit.contactPhone"></el-input>
      </el-form-item>
      <el-form-item label="排序:">
        <el-input-number v-model="unit.sort"></el-input-number>
      </el-form-item>
      <el-form-item label="简介:">
        <el-input type="textarea" v-model="unit.briefIntro"></el-input>
      </el-form-item>
    </el-form>

    <template #footer>
      <div>
        <el-button @click="visible = false;" :loading="loading">取消</el-button>
        <el-button type="primary" @click="save" :loading="loading">保存</el-button>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import { defineComponent } from 'vue';
import { getUnitById, saveUnit } from '@/api/enterprise/index';

export default defineComponent({
  emits: ['get-data'],
  data() {
    return {
      visible: false,
      loading: false,
      unit: {},
      rules: {
        name: [{required: true, message: '请填写部门名称', trigger: 'change'}],
        briefName: [{required: true, message: '请填写部门简称', trigger: 'change'}]
      }
    }
  },
  methods: {
    add(parent) {
      this.unit = {
        orgId: parent.orgId,
        pid: parent.unitId || null,
        parentName: (parent.unitId && parent.name) || null,
        sort: 1
      };
      this.$refs.unitForm && this.$refs.unitForm.clearValidate();
      this.visible = true;
    },
    edit(orgUnit) {
      this.getUnit(orgUnit);
    },
    getUnit(orgUnit) {
      getUnitById(orgUnit.unitId).then(({data}) => {
        if (data.data) {
          this.unit = data.data;
          this.unit.parentName = orgUnit.parentName;
        this.$refs.unitForm && this.$refs.unitForm.clearValidate();
          this.visible = true;
        } else {
          this.$message.error('部门不存在');
        }
      })
    },
    save() {
      this.$refs.unitForm.validate(valid => {
        if (valid) {
          this.loading = true;
          saveUnit(this.unit).then(({data}) => {
            if (data.status) {
              this.$message.success(data.msg);
              this.$emit('get-data');
              this.visible = false;
            } else {
              this.$message.warning(data.msg);
            }
          })
          this.loading = false;
        }
      })
    }
  }
})
</script>
